export default "__VITE_ASSET__DR6EMF21__"